<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3 v-if="this.otf_asset">OTF Asset - {{ otf_asset.name }}</h3>
            </b-col>
        </b-row>

        <b-form v-if="this.otf_asset" class="px-2" @submit="onSubmit">

            <b-form-group label-cols-lg="2" label="Title" label-for="input-title">
                <b-form-input id="input-title" v-model="otf_asset.name"></b-form-input>
            </b-form-group>

            <b-form-group label-cols-lg="2" label="Description" label-for="input-description">
                <b-form-textarea id="input-description" v-model="otf_asset.description" />
            </b-form-group>

            <b-form-group label-cols-lg="2" label="Is unlisted?" label-for="input-public">
                <b-form-checkbox id="input-public" class="col-form-label" v-model="otf_asset.unlisted" />
            </b-form-group>

            <b-row class="mb-3">
                <b-col md="2">
                    Created at
                </b-col>
                <b-col md="4">
                    <div>{{ new Date(this.otf_asset.created_at).toLocaleString() }}</div>
                </b-col>

                <b-col md="2">
                    Updated at
                </b-col>

                <b-col md="4" v-if="this.otf_asset.updated_at">
                    {{ new Date(this.otf_asset.updated_at).toLocaleString() }}
                </b-col>
            </b-row>

            <b-row class="mb-3" align-v="center">
                <b-col md="2">
                    OTF asset file
                </b-col>

                <b-col>
                    <a :href="otf_asset.presigned_url_zip" v-if="otf_asset.presigned_url_zip">Download file</a>
                    <input type="file" ref="otf_asset_file" class="px-2" @change="setFile">
                    <b-button variant="primary" @click="uploadFile" :disabled="!this.OtfAssetFile || uploading_file">
                        Upload OTF Asset file</b-button>
                </b-col>
            </b-row>


            <b-button type="submit" variant="primary" :disabled="uploading_file">Update OTF Asset</b-button>
            <b-button variant="danger" class="float-right" @click="deleteOtfAsset" :disabled="uploading_file">Delete OTF
                Asset</b-button>
        </b-form>

        <div>
            <h4>Space prototypes</h4>

            <b-table id="my-table-space-prototypes" v-if="this.otf_asset" :fields="space_prototypes_fields"
                :items="this.otf_asset.space_prototypes" :per-page="perPage" small striped>
                <template v-slot:cell(actions)="data">
                    <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                        @click="remove_space_prototype(data.item.uuid)" />
                </template>
                <template v-slot:cell(name)="data">
                    <router-link :to="'/prototype/' + data.item.uuid">{{ data.value }}</router-link>
                </template>

            </b-table>
        </div>

        <div>
            <h4>Space affinities</h4>

            <b-container>
                <b-row>
                    <b-col>
                        <b-button :disabled="!spaceAffinity" variant="success" @click="submitNewSpaceAffinity()"
                            class="mb-3">
                            Add OTF Affinity
                        </b-button>
                    </b-col>
                    <b-col cols="8">
                        <ejs-dropdownlist id='dropdownlist' placeholder='Start typing the name of the space' :allowFiltering='true' :filtering="filtering"
                            :dataSource='spaces' :fields='space_select_fields' v-model='spaceAffinity'>
                        </ejs-dropdownlist>
                    </b-col>
                </b-row>
            </b-container>

            <b-table id="my-table-space-affinities" v-if="this.otf_asset" :fields="space_prototypes_fields"
                :items="this.otf_asset.space_affinities" :per-page="perPage" small striped>
                <template v-slot:cell(actions)="data">
                    <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                        @click="deleteSpaceAffinity(data.item.uuid)" />
                </template>
                <template v-slot:cell(name)="data">
                    <router-link :to="'/space/' + data.item.uuid">{{ data.value }}</router-link>
                </template>

            </b-table>
        </div>

    </b-container>

</template>


<script>
import Alert from '../components/alert.vue';
import { BIconTrashFill } from 'bootstrap-vue';

export default {
    data() {
        return {
            message: '',
            otf_asset: null,
            uploading_file: false,
            OtfAssetFile: null,
            spaces: null,
            perPage: 20,
            space_prototypes_fields: [
                { key: 'name', label: 'Name', class: 'text-center align-middle', sortable: true },
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
                { key: 'actions', label: 'Actions', class: 'text-center align-middle' }
            ],
            space_select_fields: { text: "name", value: "uuid" },
            spaceAffinity: null
        }
    },
    components: {
        BIconTrashFill,
        alert: Alert,
    },
    methods: {
        filtering(e){
            if (e.text.length >= 3){
                this.download_spaces(e.text)
            }
            
        },
        init() {
            this.download_otf_asset_details();
        },
        onSubmit(event) {
            event.preventDefault()
            this.$http.patch(this.$apiURL + '/admin/otf_asset/' + this.$route.params.uuid, {
                name: this.otf_asset.name,
                description: this.otf_asset.description,
                unlisted: this.otf_asset.unlisted
            },
                { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.message = { 'message': "OTF Asset has been updated!" }
                    this.init();
                })
                .catch((error) => {
                    this.message = { 'message': error.response.data, "type": "danger" }
                });
        },
        download_spaces(filter) {
            this.$http.get(this.$apiURL + '/spaces/search',
                {
                    headers: this.$store.getters.authHeader,
                    params: { name: filter}
                })
                .then((res) => {
                    this.spaces = res.data.items
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        download_otf_asset_details() {
            this.$http.get(this.$apiURL + '/admin/otf_asset/' + this.$route.params.uuid, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.otf_asset = res.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        deleteOtfAsset() {
            this.$dialog
                .confirm("Are you sure about the delete the OTF Asset?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/admin/otf_asset/' + this.$route.params.uuid, { headers: this.$store.getters.authHeader }
                    )
                        .then((res) => {
                            this.$router.push({ name: "list_of_otf_assets", params: { message: "OTF Asset has been removed!" } })
                        })
                        .catch((error) => {
                            console.log(error)
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        });
                });
        },
        submitNewSpaceAffinity() {
            this.$http.post(this.$apiURL + '/admin/otf_asset/' + this.$route.params.uuid + "/space_affinity", { space_uuid: this.spaceAffinity }, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.spaceAffinity = null
                    this.message = { 'message': "Space Affinity has been set." }
                    this.init();
                })
                .catch((error) => {
                    console.log(error)
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                });
        },
        deleteSpaceAffinity(space_uuid) {
            this.$dialog
                .confirm("Are you sure about the delete the Space Affinity?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/admin/otf_asset/' + this.$route.params.uuid + "/space_affinity", { headers: this.$store.getters.authHeader, data: { space_uuid: space_uuid } }
                    )
                        .then((res) => {
                            this.message = { 'message': "Space Affinity has been removed." }
                            this.init();
                        })
                        .catch((error) => {
                            console.log(error)
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        });
                });
        },
        setFile() {
            this.OtfAssetFile = this.$refs.otf_asset_file.files[0];
        },
        uploadFile() {
            this.uploading_file = true;
            var formData = new FormData();
            formData.append('file', this.OtfAssetFile);
            this.$http.post(this.$apiURL + '/admin/otf_asset/' + this.$route.params.uuid, formData, {
                headers: Object.assign({}, this.$store.getters.authHeader, { 'Content-Type': 'multipart/form-data' })
            })
                .then((res) => {
                    this.OtfAssetFile = null;
                    this.$refs.otf_asset_file.value = null;
                    this.message = { 'message': "OTF Asset file has been uploaded" }
                    this.init();

                })
                .catch((error) => {
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                })
                .finally(() => {
                    this.uploading_file = false;
                });
        },
        remove_space_prototype(space_prototype_uuid) {
            this.$dialog
                .confirm("Are you sure about the delete of the space prototype?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/admin/space_prototype/' + space_prototype_uuid + '/otf_asset', { headers: this.$store.getters.authHeader, data: { otf_asset_uuid: this.$route.params.uuid } }
                    )
                        .then((res) => {
                            this.otfAsset = null
                            this.message = { 'message': "OTF Asset has been removed." }
                            this.init();
                        })
                        .catch((error) => {
                            this.message = {
                                'message': error.response.data,
                                'type': "danger"
                            }

                        });
                })
        }
    },
    created() {
        this.init();
    },
}
</script>
